// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3VN6Q","content":"GlobalSearch_content__30yeJ"};